import {
  LoginRequest as UnauthorizedLoginRequest,
  RefreshTokenRequest as UnauthorizedRefreshTokenRequest,
} from '@gem/call/WsApi/unauthorizedWsCallsApi/types/auth/auth_requests_pb';
import { LoginSuccess as UnauthorizedLoginSuccess } from '@gem/call/WsApi/unauthorizedWsCallsApi/types/auth/auth_respones_pb';

import { ILoginDeviceInfo } from 'APP/Tasks/authorization/login/login.types';
import { KeyPackageAlgorithm } from 'APP/model/e2ee/e2eeModel.types';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import { LogoutRequest } from 'APP/wsApi/wsAppApi/types/auth/auth_requests_pb';
import { LoginSuccess } from 'APP/wsApi/wsAppApi/types/auth/auth_respones_pb';
import { Platform } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';
import { User } from 'APP/wsApi/wsAppApi/types/user/user_model_pb';

export { Platform };

export interface ILoginByCode {
  code: string;
  device: ILoginDeviceInfo;
  redirectUri: string;
}

export interface IUnauthorizedLogin extends Omit<UnauthorizedLoginRequest, '$typeName'> {}

export interface IRefreshToken {
  refreshToken: string;
  device: ILoginDeviceInfo;
}

export interface IUnauthorizedRefreshToken
  extends Omit<UnauthorizedRefreshTokenRequest, '$typeName' | 'deviceInfo'> {}
export interface ILogout extends Omit<LogoutRequest, '$typeName'> {}

export interface IUser extends Omit<User, '$typeName' | 'username' | 'nickname' | 'id'> {
  id: string;
  userName: string;
  nickName: string;
  email?: string;
}

export enum ClientConfigKey {
  MessagesKeywords = 'messages.keywords',
  CallParticipantsMax = 'calls.participants.max',
  ReactionsLastUpdateTimestamp = 'reactions.last.update.timestamp',
  StickersLastUpdateTimestamp = 'stickers.last.update.timestamp',
  UserStickersLastUpdateTimestamp = 'user.stickers.last.update.timestamp',
  AdminAuthUrlBase = 'user.adminAuthUrlBase',
  UserPreferences = 'user.preferences',
  FeatureMarketSpace = 'feature.marketspace',
  RewardsStatus = 'rewards.status',
  CoinfideHost = 'coinfideHost',
  Onboarding = 'onboarding',
  WhitelistUrls = 'whitelist.urls',
  TelegramAuth = 'telegram.auth',
  SupportEmail = 'supportEmail',
  CallsProvider = 'calls.provider',
  SupportedSDKVersion = 'supportedSDKVersion',
  VideoAutoplay = 'videoAutoplay',
  ForcedUpdate = 'ForcedUpdate',
  SoftUpdate = 'SoftUpdate',
  Backgrounds = 'backgrounds',
}

export interface IClientConfigItem {
  key: ClientConfigKey;
  payload: any; // TODO: add typings
}

export interface IDeviceKeyPackagesCount {
  missingCount: number;
  availableCount: number;
  algorithm: KeyPackageAlgorithm;
}

export interface ILoginSuccess
  extends Omit<
    LoginSuccess,
    '$typeName' | 'user' | 'clientConfig' | 'deviceKeyPackagesCount' | 'deviceStatus'
  > {
  user?: IUser;
  clientConfig: IClientConfigItem[];
  deviceKeyPackagesCount: IDeviceKeyPackagesCount | null;
  deviceStatus?: DeviceStatus;
}

export interface IUnauthorizedLoginSuccess extends Omit<UnauthorizedLoginSuccess, '$typeName'> {}

export interface IAccountProvider {
  authProviderId: AuthProvider;
  displayName: string;
  userId: string;
}

export interface IClientConfigBackground {
  id: string;
  order: number;
  url: string;
  averageColor: string;
}

export type IClientConfigProperty = {
  id?: string;
  key: string;
  type: string;
  value: string;
  segmentId: string;
  adminAuthUrlBase?: string;
  backgrounds: IClientConfigBackground[];
};

enum ExternalAuthProviderId {
  Google = 'GOOGLE',
  Telegram = 'TELEGRAM',
  Apple = 'APPLE',
  Phone = 'PHONE',
}

export type AuthProvider = ExternalAuthProviderId;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthProvider = ExternalAuthProviderId;

export interface IAuthUrlSuccess {
  authUrl: string;
  supportEmail: string;
}

export interface IRegistrationUrlSuccess {
  registrationUrl: string;
  adminUiUrl: string;
  supportEmail?: string;
}

export enum LoginErrors {
  DeviceIsBlocked = 'deviceIsBlocked',
}
